import { createContext } from '@lit/context';

export type AuthState = {
  userId: null | string;
  user: null | {
    id: string;
    display_name: string;
    avatar_url: string;
  };
};

export const authContext = createContext<AuthState>('auth');

